// semeia-disable-reexport
// TODO: refactor this to use the database content
const dosageRelationshipDefinitions = [{
  name: "Tacrolimus",
  orderCode: "LOINC-77348-1",
  resultCode: "LOINC-77348-1"
}, {
  name: "Ciclosporine",
  orderCode: "LOINC-53828-0",
  resultCode: "LOINC-53828-0"
}, {
  name: "Sirolimus",
  orderCode: "LOINC-72676-0",
  resultCode: "LOINC-72676-0"
}, {
  name: "Évérolimus",
  orderCode: "LOINC-72671-1",
  resultCode: "LOINC-72671-1"
}];
const bioExamResultCodeFromOrderCode = {};
for (const relationship of dosageRelationshipDefinitions) {
  bioExamResultCodeFromOrderCode[relationship["orderCode"]] = relationship["resultCode"];
}
export { bioExamResultCodeFromOrderCode };